import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import StoreNav from '../components/StoreNav';

const SUPPORT = {
  email:   process.env.REACT_APP_SUPPORT_EMAIL   || 'mafifah.usr@gmail.com',
  phone:   process.env.REACT_APP_SUPPORT_PHONE   || '+62 812-3456-7890',
  address: process.env.REACT_APP_SUPPORT_ADDRESS || 'Pamekasan, Jawa Timur, Indonesia',
};

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

export default function OrderSuccess() {
  const { id } = useParams();
  const nav = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, [id]);

  async function load() {
    // Coba order PO dulu, kalau tidak ada baru cek order menu POS (web)
    const { data: po } = await supabase
      .from('po_orders')
      .select('*, customer:customers(*), po_order_items(*)')
      .eq('id', id).maybeSingle();
    if (po) {
      setOrder({ kind: 'po', ...po, items: po.po_order_items || [] });
      setLoading(false);
      return;
    }

    const { data: pos } = await supabase
      .from('pos_orders')
      .select('*, customer:customers(*), order_items(*)')
      .eq('id', id).maybeSingle();
    if (pos) {
      setOrder({ kind: 'pos', ...pos, items: pos.order_items || [] });
    }
    setLoading(false);
  }

  if (loading) return (
    <div className="store" style={{ minHeight: '100vh' }}>
      <StoreNav />
      <div style={{ textAlign: 'center', padding: 60, color: 'var(--ink-soft)' }}>Memuat...</div>
    </div>
  );

  if (!order) return (
    <div className="store" style={{ minHeight: '100vh' }}>
      <StoreNav />
      <div style={{ textAlign: 'center', padding: 60, color: 'var(--ink-soft)' }}>Pesanan tidak ditemukan.</div>
    </div>
  );

  const isDelivery = order.kind === 'po' ? order.fulfillment_type === 'delivery' : order.type === 'Delivery';
  const caraTerima = order.kind === 'po'
    ? (order.fulfillment_type === 'delivery' ? 'Diantar' : 'Ambil Sendiri')
    : order.type;

  return (
    <div className="store" style={{ minHeight: '100vh', paddingBottom: 60 }}>
      <StoreNav />
      <div style={{ maxWidth: 520, margin: '0 auto', padding: '28px 20px' }} className="fade-up">
        <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 'var(--store-radius)', padding: '36px 26px', textAlign: 'center', boxShadow: 'var(--store-shadow)' }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--primary-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem', color: 'var(--ink)', marginBottom: 8 }}>Pesanan Diterima!</div>
          <p style={{ fontSize: '.86rem', color: 'var(--ink-soft)', lineHeight: 1.7, marginBottom: 24 }}>
            {order.kind === 'po'
              ? `Kami akan mengirim konfirmasi via WhatsApp. Bayar tunai saat pesanan ${isDelivery ? 'sampai di lokasimu' : 'kamu ambil'}.`
              : `Pesanan kamu sedang disiapkan dapur kami. Bayar tunai saat pesanan ${isDelivery ? 'sampai di lokasimu' : 'kamu ambil'}.`}
          </p>

          <div style={{ background: 'var(--sand)', borderRadius: 12, padding: '16px 18px', marginBottom: 22, textAlign: 'left' }}>
            {[
              ['Order ID', order.id],
              ['Nama', order.customer?.name || order.customer_name],
              ['Cara Terima', caraTerima],
              order.kind === 'po' ? ['Tanggal', fmtDate(order.fulfillment_date)] : null,
              isDelivery ? ['Alamat', order.delivery_address] : null,
            ].filter(Boolean).map(([k, v]) => v ? (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '6px 0', borderBottom: '1px solid var(--line)', fontSize: '.82rem' }}>
                <span style={{ color: 'var(--ink-soft)', flexShrink: 0 }}>{k}</span><strong style={{ textAlign: 'right', color: 'var(--ink)' }}>{v}</strong>
              </div>
            ) : null)}

            {order.items.map(i => (
              <div key={i.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--line)', fontSize: '.82rem' }}>
                <span style={{ color: 'var(--ink-soft)' }}>{(order.kind === 'po' ? i.variant_name : i.display_name)} × {i.qty}</span>
                <strong>Rp {Number(order.kind === 'po' ? i.subtotal : i.unit_price * i.qty).toLocaleString('id-ID')}</strong>
              </div>
            ))}

            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0 0', fontSize: '.9rem', fontWeight: 700 }}>
              <span>Total COD</span>
              <span style={{ color: 'var(--primary)' }}>Rp {Number(order.total).toLocaleString('id-ID')}</span>
            </div>
          </div>

          <button onClick={() => nav('/')} style={{ padding: '10px 24px', borderRadius: 999, background: 'var(--ink)', color: '#fff', border: 'none', fontSize: '.84rem', fontWeight: 700 }}>
            Pesan Lagi
          </button>

          <div style={{ marginTop: 24, paddingTop: 18, borderTop: '1px solid var(--line)', textAlign: 'left', fontSize: '.76rem', color: 'var(--ink-soft)', lineHeight: 1.8 }}>
            <div style={{ fontWeight: 700, color: 'var(--ink)', marginBottom: 4 }}>Hubungi Kami</div>
            <div>{SUPPORT.email}</div>
            <div>{SUPPORT.phone}</div>
            <div>{SUPPORT.address}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
